export const Locations = {
  en: {
    Locations: 'Locations',
    'Create Location': 'Create Location',
    'Fiscal registrars': 'Fiscal registrars',
    Kind: 'Kind',
    location_kind_physical: 'Physical',
    location_kind_online: 'Online',
    location_kind_head_office: 'Head Office',
  },
  uk: {
    Locations: 'Локації',
    'Create Location': 'Створити локацію',
    'Fiscal registrars': 'Фіскальні реєстратори',
    Kind: 'Тип',
    location_kind_physical: 'Фізична',
    location_kind_online: 'Онлайн',
    location_kind_head_office: 'Головний офіс',
  },
};

export const LocationForm = {
  en: {
    ...Locations.en,
    'New Location': 'New Location',
    'Edit Location': 'Edit Location',
    'Update Location': 'Update Location',
    Location: 'Location',
    Back: 'Back',
    special_location_banner:
      'This is a system-managed location controlled by a feature toggle via System Owner. Name and settings cannot be changed; contact support to change the feature status.',
    Website: 'Website',
    'Location on Google Maps': 'Location on Google Maps',
    'Choose Image File': 'Choose Image File',
    'Active For Booking': 'Active For Booking',
    active_for_booking_hint:
      'Off — the location offers no booking slots and is hidden from the client list. Turn it on to show the location before it has any bookings.',
    'VAT enabled': 'VAT enabled',
    'Booking description': 'Description for booking page',
    booking_description_hint:
      'Shown to the client on the location card in the booking flow.',
    Address: 'Address',
    Phone: 'Phone',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Coordinates: 'Coordinates',
    Lat: 'Latitude',
    Lng: 'Longitude',
    'Work time': 'Work time',
  },
  uk: {
    ...Locations.uk,
    'New Location': 'Нова Локація',
    'Edit Location': 'Редагування Локації',
    'Update Location': 'Оновити Локацію',
    Location: 'Локація',
    Back: 'Назад',
    special_location_banner:
      'Це системна локація, керована функціональною опцією через System Owner. Назва і налаштування не змінюються; для зміни статусу зверніться до підтримки.',
    Website: 'Сайт',
    'Location on Google Maps': 'Локація на Google Maps',
    'Choose Image File': 'Вибрати зображення',
    'Active For Booking': 'Активний для бронювання',
    active_for_booking_hint:
      'Вимкнено — локація не дає слотів для запису і не показується клієнту. Увімкніть, щоб показати локацію ще до перших бронювань.',
    'VAT enabled': 'ПДВ ввімкнено',
    'Booking description': 'Опис для сторінки бронювання',
    booking_description_hint:
      'Показується клієнту на картці локації у флоу бронювання.',
    Address: 'Адреса',
    Phone: 'Телефон',
    Monday: 'Понеділок',
    Tuesday: 'Вівторок',
    Wednesday: 'Середа',
    Thursday: 'Четвер',
    Friday: "П'ятниця",
    Saturday: 'Субота',
    Sunday: 'Неділя',
    Coordinates: 'Координати',
    Lat: 'Широта',
    Lng: 'Довгота',
    'Work time': 'Робочий час',
  },
};
